import DeviceGroupFirmwaresTab from 'src/components/pages/DeviceGroupPage/DeviceGroupFirmwaresTab/DeviceGroupFirmwaresTab';

export default DeviceGroupFirmwaresTab;
